<script lang="tsx">
import { defineComponent, toRef, type PropType } from 'vue'
import { createNamespace } from '@bd/vue3-utils'
import { FormItem } from '-/Common/Form'
import { InputRmb } from '-/Common/Input'
import { getRequiredRule } from '@/constant/form'
const [name] = createNamespace('CurrencyCenterResettleStandardForm')

export default defineComponent({
  name,
  props: {
    dataSync: {
      type: Object as PropType<Partial<ApiJtProj.ResettleStandardData>>
    }
  },
  setup(props) {
    const data = toRef(props, 'dataSync', {})
    return () => (
      <div class='ant-row-form-item'>
        安置标准：
        <FormItem name='huoBiHuaAnZhiChengQu' rules={getRequiredRule('货币安置标准')}>
          <InputRmb v-model:value={data.value.huoBiHuaAnZhiChengQu} style='width: 150px' addonAfter='元/人' />
        </FormItem>
        (包括过渡费、简装补助等)执行。
      </div>
    )
  }
})
</script>
